import { SnEsriQueryLayer } from './esri-query-layer';
import { SnEsriStreamLayer } from './esri-stream-layer';
import { SnExternalLayer } from './external-layer';
import { SnGeoJSONLayer } from './geo-json-layer';
import { SnIntegrationLayerType } from './integrations/types';
import { SnInternalGeoJSONLayer } from './internal-geo-json-layer';
import { SnInternalLayer } from './internal-layer';

export type SnLayer =
  | SnInternalLayer
  | SnExternalLayer
  | SnEsriStreamLayer
  | SnEsriQueryLayer
  | SnGeoJSONLayer
  | SnInternalGeoJSONLayer
  | SnIntegrationLayerType;
